export default __webpack_public_path__ + "static/media/p9.c3c4537f.png";